export const releaseInfo = {
    version: '387566b4',
}
